export function getLocation(timeout = 15000) {
  return new Promise((resolve, reject) => {
    if (!navigator.geolocation) return reject(new Error('This browser cannot share location.'));
    navigator.geolocation.getCurrentPosition(
      p => resolve({ lat: p.coords.latitude, lng: p.coords.longitude, accuracy: p.coords.accuracy || 0 }),
      err => reject(new Error(err.code === 1
        ? (window.self !== window.top
          ? 'Location cannot be shared from inside an embedded preview. Open the CRM in its own browser tab, then try again.'
          : 'Location access is blocked. Allow location for this site in your browser settings (padlock icon next to the address), then try again. On Windows, also check Settings → Privacy & security → Location is turned on.')
        : 'Could not get your location. Check location services are on and try again.')),
      { enableHighAccuracy: true, timeout, maximumAge: 60000 },
    );
  });
}
